import { render, staticRenderFns } from "./UserCenterSideBar.vue?vue&type=template&id=09ef6d4c&scoped=true"
import script from "./UserCenterSideBar.vue?vue&type=script&lang=js"
export * from "./UserCenterSideBar.vue?vue&type=script&lang=js"
import style0 from "./UserCenterSideBar.vue?vue&type=style&index=0&id=09ef6d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ef6d4c",
  null
  
)

export default component.exports